import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/reports")({
  beforeLoad({ context: { user } }) {
    if (!user.isLabRole()) {
      throw notFound();
    }
  },
});
